var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"ui_checkbox",class:{ on: !!this.value, disabled: !!this.disabled },on:{"click":_vm.onClick}},[_c('i',{staticClass:"icon icon--chkbox",class:{ unselect: this.unselect }}),_c('span',{staticClass:"text"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }